{
  "navigation": {
    "dashboard": "الرئيسية"
  },
  "user": {
    "notifications": "الإشعارات"
  },
  "nav": {
    "mainNavigation": "التنقل الرئيسي",
    "toggleSidebar": "إظهار/إخفاء القائمة الجانبية",
    "toggleSidebarHint": "إظهار أو إخفاء القائمة",
    "home": "الرئيسية",
    "exchange": "نظام صرف عملات",
    "exchangeVip": "نظام صرف عملات (VIP)",
    "balance": "رصيد الصندوق",
    "changeBranch": "تغيير الفرع",
    "systems": "الأنظمة",
    "cashEntries": "المقبوضات والمدفوعات"
  },
  "brand": "المسافر"
}
